module.exports = __webpack_public_path__ + "img/nestle.81e024d9.png";